@for (item of templates$ | async; track templateTrackBy($index, item)) {
  @if (item.type === 'menu') {
    <aza-rws-popup-menu
      [templateData]="item.templateData"
      [templateRef]="item.templateRef"
      [triggerHost]="item.triggerHost"
    ></aza-rws-popup-menu>
  }
}
